import AdminsPage from './AdminsPage';

export default AdminsPage;
